// $(document).on("input", "#ring_slide", function() {
$('#ring_slide').on('input', function() {  
    $('#ring_size').html(this.value);
    $('#ring_size-cm').html(this.value/10);  
    let size = ((this.value) * 3.78 + 'px');
    $('.ring_img').css({
        'width': size,
    });

    showResults(2);
});


 
function gotoStep(number){
  document.querySelectorAll('.interfaces').forEach(item => {
    item.classList.remove('active');
  });
  document.querySelector(`.interfaces[data-step='${number}']`).classList.add('active');
}



/* range slider */
(function() {
	var parent = document.querySelector("#rangeSlider");
	if(!parent) return;

	var
      range = parent.querySelector("input[type=range]"),
      numberS = parent.querySelectorAll("input[type=number]");
      range.oninput = function() {
        var slide = parseFloat(range.value);
        numberS[0].value = slide;

        document.querySelector('.js-output-range').innerHTML=slide;
        document.querySelector('.js-output-range-cm').innerHTML=slide/10;

        showResults(1);
      }

	numberS.forEach(function(el) {
		el.oninput = function() {
			var number1 = parseFloat(numberS[0].value),
				number2 = parseFloat(numberS[1].value);

			if (number1 > number2) {
				var tmp = number1;
				numberS[0].value = number2;
				numberS[1].value = tmp;
			}

			rangeS[0].value = number1;
			rangeS[1].value = number2; 
          
		}
	});

  })();



/* results */
function showResults(decide){
    var sizeinmm = 30;
  
    if(decide == 1){
      sizeinmm = parseInt(document.querySelector('input#range-input').value);
    }else{
      sizeinmm = parseInt(document.querySelector('input#ring_slide').value);
    }
 

      var sizeGuideForWomen = "S",sizeGuideFormen = "S";

      // MEN S(56),M(60),L(64)
      if(sizeinmm >= 61)
      {
        // 61 and above -> L
        sizeGuideFormen="L";
      }else if(sizeinmm >= 57)
      {
        // 57 and above till 60 -> M
        sizeGuideFormen="M";
      }else{
        // Below 57 -> S
        sizeGuideFormen="S";
      }




      // WOMEN XXS(48),XS(50),S(52),M(54),L(56),XL(58),XXL(60)
      if(sizeinmm >= 59)
      {
        // 59 and above -> XXL
        sizeGuideForWomen="XXL";
      }else if(sizeinmm >= 57)
      {
        // 57 and above -> XL
        sizeGuideForWomen="XL";
      }else if(sizeinmm >= 55)
      {
        // 55 and above -> L
        sizeGuideForWomen="L";
      }else if(sizeinmm >= 53)
      {
        // 53 and above -> M
        sizeGuideForWomen="M";
      }else if(sizeinmm >= 51)
      {
        // 51 and above -> S
        sizeGuideForWomen="S";
      }else if(sizeinmm >= 49)
      {
        // 49 and above -> XS
        sizeGuideForWomen="XS";
      }else
      {
        // Below 49 -> XXS
        sizeGuideForWomen="XXS";
      }


      var resultmessage;  

      if(decide == 1){
        resultmessage = document.querySelector('p.js-size-message1');
      }else{
        resultmessage = document.querySelector('p.js-size-message2');
      }
  
      resultmessage.querySelector('span.menCategory').innerHTML = sizeGuideFormen;
      resultmessage.querySelector('span.womenCategory').innerHTML = sizeGuideForWomen;
       
  
    //var modal = document.getElementById("myModal");
    //modal.style.display = "none";
    
    //if(document.querySelector('video.viodeofaq'))document.querySelector('video.viodeofaq').pause();

    //gotoStep(0);
}









if(localStorage.getItem('selectionValue') == "men"){
  //men
  var firstOne = document.querySelector("#ring_slide");
  if(firstOne){
   firstOne.setAttribute("min",54);
   firstOne.setAttribute("max",64);
  }

  var secondOne = document.querySelector("#range-input");
  if(secondOne){
   secondOne.setAttribute("min",54);
   secondOne.setAttribute("max",64);
  }
  
}else{
  //women
  var firstOne = document.querySelector("#ring_slide");
  if(firstOne){
   firstOne.setAttribute("min",45);
   firstOne.setAttribute("max",60);
  }

  var secondOne = document.querySelector("#range-input");
  if(secondOne){
   secondOne.setAttribute("min",45);
   secondOne.setAttribute("max",60);
  }
}







